<template>
    <div >
        <div class="klrr" v-loading="loading">
            <div class="fs28 cl3">{{a_name}}</div>
            <div class="rich-box mt50" v-html="a_data"></div>
            <div class="flx jcfe mt40 fs16 cl6">{{article_year}} {{article_date}}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Articledetails',    
    data () {
        return {
            loading: true,
            a_data: '',
            a_name: '',
            article_date: '',
            article_year: ''
        }
    },
    methods:{
        getData2() {
            var that = this;
            this.$post('index.php?s=/api/index/article_info', {
                wxapp_id: 10001,
                id: this.id
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = this.showHtml(res.data.list.article_content);
                    a_data = a_data.replace(/<\/?br[^>]*>/gi,'')
                    this.a_data = a_data;
                    this.a_name = res.data.list.article_title;
                    this.article_year = res.data.list.article_year;
                    this.article_date = res.data.list.article_date;
                    setTimeout(function () {
                        that.loading = false;
                    }, 600)
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/&amp;nbsp;/g,'\u3000')
        },
    },
    created() {
        var data = this.$route.query;
        this.id = data.id;
        this.getData2();
        document.title = '文章详情';
    },
    mounted() {

	},
}
</script>

<style scoped>
    .klrr{
        width: 1200px;
        min-height: 500px;
        margin: 120px auto;
    }
    .rich-box >>> img{
        width: 100%;
    }
    .rich-box >>> p{
        font-size: 15px;
        word-wrap: break-word;
        line-height: 26px;
    }
</style>


// WEBPACK FOOTER //
// src/components/article/articledetails.vue